import React from 'react'
import { Link } from 'react-router-dom'
import heroBake from '../../assets/images/cake_bg2.jpg'

const HomeHeader = ({
  title = 'Deliciously Baked, Lovingly Made',
  subtitle1 = 'Handcrafted cakes and pastries that bring joy to every occasion,',
  subtitle2 = 'made with the finest ingredients and a touch of love.',
}) => {
  const words = title.trim().split(/\s+/)
  const scriptWord = words[0] || title
  const solidWords = words.slice(1).join(' ')

  return (
    <section className="hero-wrap">
      <svg className="hero-wrap__defs" width="0" height="0" aria-hidden="true">
        <defs>
          <clipPath id="hero-blob" clipPathUnits="objectBoundingBox">
            {/* warped organic cut — not oval */}
            <path d="M0.58 0.01
              C0.74 -0.01 0.90 0.06 0.95 0.18
              C1.01 0.32 0.97 0.42 0.99 0.52
              C1.02 0.66 0.94 0.78 0.86 0.88
              C0.74 1.02 0.52 1.01 0.36 0.96
              C0.22 0.92 0.08 0.90 0.03 0.76
              C-0.02 0.62 0.04 0.54 0.02 0.40
              C0.00 0.26 0.02 0.14 0.14 0.08
              C0.28 0.01 0.40 0.04 0.58 0.01 Z" />
          </clipPath>
        </defs>
      </svg>

      <div className="hero-wrap__grid">
        <div className="hero-wrap__copy">
          <p className="hero-wrap__brand text-logo">Cake by Sandy</p>
          <p className="hero-wrap__kicker">Custom cakes · Portland vibes</p>
          <h1>
            <span className="hero-wrap__script">{scriptWord}</span>
            {solidWords ? <span className="hero-wrap__solid">{solidWords}</span> : null}
          </h1>
          <p className="hero-wrap__text">
            {subtitle1}
            {subtitle2 ? ` ${subtitle2}` : ''}
          </p>
          <div className="hero-wrap__actions">
            <Link to="/book" className="hero-wrap__cta">
              Order Now
            </Link>
            <Link to="/gallery" className="hero-wrap__ghost">
              See gallery
            </Link>
          </div>
        </div>

        <figure className="hero-wrap__media">
          <div className="hero-wrap__scene" aria-hidden="true">
            <span className="hero-wrap__wash" />
            <span className="hero-wrap__orb hero-wrap__orb--lg" />
            <span className="hero-wrap__orb hero-wrap__orb--sm" />
            <span className="hero-wrap__spark hero-wrap__spark--1" />
            <span className="hero-wrap__spark hero-wrap__spark--2" />
            <span className="hero-wrap__spark hero-wrap__spark--3" />
            <span className="hero-wrap__dot hero-wrap__dot--1" />
            <span className="hero-wrap__dot hero-wrap__dot--2" />
            <span className="hero-wrap__dot hero-wrap__dot--3" />
          </div>

          <div className="hero-wrap__frame">
            <img src={heroBake} alt="Freshly baked cakes and cupcakes" />
          </div>
        </figure>
      </div>
      <div className="hero-wrap__slant" aria-hidden="true" />
    </section>
  )
}

export default HomeHeader
